"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var is_same_day_1 = require("./is-same-day");

function isTomorrow(date, timeZone) {
  var now = new Date();
  var tomorrow = new Date(now.valueOf() + 24 * 60 * 60 * 1000);
  return is_same_day_1.isSameDay(date, tomorrow, timeZone);
}

exports.isTomorrow = isTomorrow;